import RoomClient from 'components/containers/utils/mediaSoup/RoomClient';
import { userInfoMapperSocket } from 'components/containers/utils/sockets/userInfoMapperSocket';
import React, { useEffect, useRef, useState, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { csModalType, csSubtype, socketMessageSubType, socketMessageType } from 'types/Constants';
import SocketContext from 'socket-context';
import { socketContextType } from 'index';
import { User } from 'models/User';
import { Flex, Button, Text, Box } from '@radix-ui/themes';
import BottomMessage from '../Group_Discussion/BottomMessage';
import BottomMessageWithIcon from '../Group_Discussion/BottomMessageWithIcon';
import MyPeerView from 'components/classroom/components/Peers/MyPeerView';
import Trainer from 'components/classroom/components/backup/Trainer';
import { validateAndCreateSocketIfExist } from 'utils/SocketValidator';
import CsSetup from './CsSetup';
import CsReadyToPresent from './CsReadyToPresent';
import CsStartPresenter from './CsStartPresenter';
import CsEndWait from './CsEndWait';
import CsCompletePreparation from './CsCompletePreparation';
import CsWait from './CsWait';
import CsCommence from './CsCommence';
import CsGroupOrder from './CsGroupOrder';
import CsVideoChatRequest from './CsVideoChatRequest';
import CsYouNext from './CsYouNext';
import CsPresentationRankOrder from './CsPresentationRankOrder';
import TableElement from 'components/classroom/components/TableElement';
import PeerView from 'components/classroom/components/Peers/PeerView';
import AsktoPresentCS from './AsktoPresentCS';
import CsOpenClassInteraction from './CsOpenClassInteraction';
import CSTable from './CsTable';
import exitPresentation from "../../../assets/images/exitPresentation.png";
import axiosInstance from 'config/axios';
import { UserInfoMapperSocketHandler } from 'utils/UserInfoMapper';
import ParticipantNew from 'components/classroom/components/backup/ParticipantNew';
import OpenClassInteraction from 'components/classroom/components/backup/OpenClassInteraction';
import TableElementNew from 'components/classroom/components/TableElementNew';
import { groupBy } from 'utils/StreamingHelperFunctions';
import briefIcons from "../../../assets/images/BriefIcons.png";
import { csCaseStudyParticipants } from 'store/reducers/countReducer';
import { updateLiveStreamSettings } from 'store/reducers/livestreamSettings';
import CSGroupleader from './CSGroupleader';
import CsNominateGroupleader from './CsNominateGroupleader';

type csProps = {
  sessionId: any;
  activityData: any,
  onBrief: (val: any) => void;
  tableData?: (val: any) => void;
  showViewCaseTitle?: (val: boolean) => void;
  showPresentModal?: () => void;
  roomClient?: RoomClient | null;
  documentUrl?: string;
};
const CaseStudyScreen = ({ roomClient, sessionId, onBrief, tableData, showViewCaseTitle = (value: boolean) => { }, showPresentModal = () => { }, documentUrl, activityData }: csProps) => {
  console.log("CS1234 CaseStudyScreen documentUrl", documentUrl)
  console.log("CS1234 CaseStudyScreen activityData", activityData)
  let userInfoHandler = useRef<UserInfoMapperSocketHandler>();
  const dispatch = useDispatch();
  // @ts-ignore
  const socketList: socketContextType[] = useContext(SocketContext);

  const profileData = useSelector((state: RootState) => state?.auth?.user as User);
  const batchData = useSelector((state: RootState) => state.live.settings?.batch);
  const session_id = useSelector((state: RootState) => state?.live.settings.roomId);
  const consumers = useSelector((state: RootState) => state.live.settings.consumers);
  const producers = useSelector((state: RootState) => state.live.settings.producers);
  const shareConsumer: any = Object.values(consumers || {}).find((consumer: any) => consumer.appData?.share === true);
  const { trainer } = useSelector((state: RootState) => state.live.settings);

  const [modalMode, setModalMode] = useState<any>(csModalType.SETUP);
  const [newTableData, setNewTableData] = useState()
  const [openClassInteraction, setOpenClassInteraction] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showNominateModal, setShowNominateModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [tblData, setTblData] = useState<any>({});
  const [newTblData, setNewTblData] = useState<any>([]);
  const [tblDataSnap, setTblDataSnap] = useState<any>({});
  const [groupleader, setGroupleader] = useState(undefined);
  const [groupOrder, setGroupOrder] = useState<any[]>([]);
  const [briefMode, setBriefMode] = useState<string>("");
  const [canTransfer, setCanTransfer] = useState(true);
  const [randomlySelected, setRandomlySelected] = useState({})
  const [GLMmode, setGLMmode] = useState<string>('')
  const [shareStream, setShareStream] = useState({ toURL: () => { } });
  const [spotlightTable, setSpotlightTable] = useState<any>({});
  const [messageCxt, setMessageCxt] = useState<{ visible: boolean, message: string }>({ visible: false, message: '' })

  const [isIamRepresentingGroup, setIsIamRepresentingGroup] = useState(false);
  const [hardCopyModifiedGroupTableData, setHardCopyModifiedGroupTableData] = useState({});
  const [hideOurDraggableView, setHideOurDraggableView] = useState(false)
  const [removedEmail, setRemovedEmail] = useState('');
  const [manuallySelected, setmanuallySelected] = useState<any>();
  const [myEmailInPresentation, setMyEmailInPresentation] = useState({ participant_email: "no email" });
  const [showMyfeed, setShowMyfeed] = useState(true);
  const [groupLeaderUpdated, setgroupLeaderUpdated] = useState<any>();
  const csSelectedTraineeForPresentation = useSelector((state: any) => state.countReducer?.csSelectedTraineeForPresentation);
  const dropoutState = useSelector((state: any) => state.countReducer?.response);

  const groupleaderRef = useRef<any>();
  groupleaderRef.current = groupleader;

  const GLMmodeRef = useRef<any>();
  GLMmodeRef.current = GLMmode;

  const tblDataRef = useRef<any>();
  tblDataRef.current = tblData;
  const [fileToPresent, setFileToPresent] = useState('');
  const [presentaionType, setPresentaionType] = useState('')

  // private video chat
  const [whoIsAsking, setWhoIsAsking] = useState<any>({})
  const [isPrivateVideoChat, setIsPrivateVideoChat] = useState(false)
  const [privateVideoChatParticipents, setPrivateVideoChatParticipents] = useState<any[]>([])
  // *** streamming ***

  const [myStream, setMyStream] = useState<any>({})
  const [otherStream, setOtherStream] = useState<any>({})
  const [allStream, setAllStream] = useState<any>({})
  const [minutes, setMinutes] = useState(0);

  const [showStartPresentation, setShowStartPresentation] = useState(false)
  const [isPresentationStarted, setIsPresentationStarted] = useState(false)
  const [presentaionData, setPresentaionData] = useState<{ presentNominee: string, activePresentation: string, fileUrl: string }>({ presentNominee: '', activePresentation: '', fileUrl: '' })

  const [isGlTransfer, setIsGlTransfer] = useState(false)
  const [showMenu, setShowMenu] = useState(false)
  const [showFullscreen, setShowFullscreen] = useState(false)
  const [unspotlight, setUnspotlight] = useState<boolean>(false);


  // timer
  const [timeLeft, setTimeLeft] = useState(null);
  const [isTwoMinutesLeft, setIsTwoMinutesLeft] = useState(false);
  const [extendedTime, setExtendedTime] = useState({
    visible: false,
    time: 0
  })

  const [presentationOrder, setPresentationOrder] = useState<any>({
    groupName: '',
    rankOrder: '',
    traineeDetails: {},
    isOurGroupIsGoingToRepresent: false,
    presenterGroup: {},

  });
  const [isUsersDragableCompOpen, setIsUsersDragableCompOpen] = useState(false);
  const [isExpandedTabel, setIsExpandedTabel] = useState(false);
  const [isUsersDragableCompOpens, setIsUsersDragableCompOpens] = useState(false);
  const [layoutHeight, setLayoutHeight] = useState(0);
  const [boxSize, setBoxSize] = useState({ height: 0, width: 0 });
  const containerRef = useRef<HTMLDivElement>(null);
  const [isTrainerPresent, setIsTrainerPresent] = useState({});


  // am i mute>>>
  let userMicState = useSelector((state: any) => state.countReducer?.micState);
  const [amImute, setAmImute] = useState(false);
  const [csMinutes, setCSMinutes] = useState(0);
  const [csSeconds, setCSSeconds] = useState(0);
  const [isCsTimerActive, setIsCsTimerActive] = useState(false);
  const caseStudyExtendTimeIdRef = useRef(null);
  const presentationDurationRef = useRef<number>(0);
  const lastExtendEventIdRef = useRef(null);


  // const [justBecameGroupLeader, setJustBecameGroupLeader] = useState(false);

  // Countdown logic
  useEffect(() => {
    let interval = null;

    if (isCsTimerActive) {
      interval = setInterval(() => {
        if (csSeconds > 0) {
          setCSSeconds(csSeconds - 1);
        } else if (csMinutes > 0) {
          setCSMinutes(csMinutes - 1);
          setCSSeconds(59);
        } else {
          // Timer completed
          setIsCsTimerActive(false);
          clearInterval(interval);
        }
      }, 1000);
    } else if (!isCsTimerActive && csMinutes !== 0 && csSeconds !== 0) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [isCsTimerActive, csMinutes, csSeconds]);
  useEffect(() => {
    userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
  }, []);

  useEffect(() => {
    tableData(tblData);
  }, [tblData]);

  useEffect(() => {
    const producersArray = Object.values(producers);

    const videoProducer: any = producersArray?.find(
      (producer: any) =>
        producer.kind === "video"
    );
    if (videoProducer) {
      const stream = new MediaStream();
      stream.addTrack(videoProducer.track);
      setMyStream({ [profileData?.email]: stream });
    } else {
      setMyStream({ [profileData?.email]: { toURL: () => { } } });
    }
  }, [producers]);

  useEffect(() => {
    if (consumers) {
      let _consumers = Object?.values(consumers);
      let newConsumerArray = groupBy(_consumers, "peerId");
      let _newConsumerArray = Object.values(newConsumerArray);
      let origianlStreamArray: any;
      _newConsumerArray &&
        _newConsumerArray?.map((c: any, i: number) => {
          let stream = new MediaStream();
          let peerId: any;
          c?.map((c1: any, i1: number) => {
            stream?.addTrack(c1?.track);
            peerId = c1?.peerId;
          });
          origianlStreamArray = { ...origianlStreamArray, [peerId]: stream };
        });
      if (origianlStreamArray) {
        setOtherStream(origianlStreamArray);
      }
    }
  }, [consumers]);

  useEffect(() => {
    console.log('tblData changed:::::::::::::: bye1', newTblData)
  }, [newTblData])

  // useEffect(() => {
  //   if (dropoutState) {
  //     processSocketEvents(dropoutState);
  //   }
  // }, [dropoutState]);

  useEffect(() => {
    console.log('otherStream', otherStream);
    console.log('myStream', myStream);

    setAllStream({ ...otherStream, ...myStream });
  }, [otherStream, myStream]);

  useEffect(() => {
    if (unspotlight) {
      console.log('unspotlight:::::::::::::::1', tblDataSnap)
      setTblData(tblDataSnap)
    }
  }, [unspotlight])

  useEffect(() => {
    const myEmailInPresentations = manuallySelected?.seats.find((item) => item.participant_email === profileData?.email)
    setMyEmailInPresentation(myEmailInPresentations)
    // if (profileData?.trainee_email === myEmailInPresentations?.participant_email) {
    //     showPresentModal()
    // }
  }, [manuallySelected])

  const startPresentation = () => {
    let payload = {
      sub_type: csSubtype?.LAUNCH_PRESENTATION_SCREEN,
      type: socketMessageType?.CASE_STUDY,
      room_id: sessionId,
      activityData: {
        activePresentation: presentaionType,
        fileUrl: fileToPresent,
        presentNominee: profileData?.email,
        myGroups: tblDataRef?.current?.seats
      }
    }
    if (presentaionType == 'share_screen') {
      roomClient.enableShare() // share user's screen
    }
    setShowStartPresentation(false);
    // setIsIamRepresentingGroup(true);
    userInfoHandler.current.initSocket(sessionId, handleOnMessage);
    userInfoHandler.current.sendMessage(JSON.stringify(payload));
  }

  const startTimer = (minutes: any) => {
    setTimeLeft(Number(minutes) * 60);
  };

  const processSocketEvents = async (dropoutState: any) => {
    if (!dropoutState || !dropoutState.socketEvents) {
      console.error('processSocketEvents: dropoutState is undefined, invalid, or socketEvents is missing');
      return;
    }
    try {
      //   dispatch(storeResponse(dropoutState));
      if (Array.isArray(dropoutState.socketEvents)) {
        for (let i = 0; i < dropoutState.socketEvents.length; i++) {
          const event = dropoutState.socketEvents[i];
          console.log(`--- Starting event #${i} ---`);
          try {
            await handleOnMessage(event.message);
            // Wait for 1 second so the UI can update and user can see the change
            await new Promise(resolve => setTimeout(resolve, 1000));
            console.log(`✓ Finished event #${i}`);
          } catch (e) {
            console.error(`✗ Error in event #${i}:`, e);
          }
        }
      } else {
        console.log("No socketEvents found in the response or socketEvents is not an array.");
      }

    } catch (error) {
      console.error("Error in processSocketEvents:", error);
    }
  };

  const nominateGroupleader = (nominee: any) => {
    if (nominee) {
      if (!userInfoHandler.current) {
        userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
      }
      //To be kept for hiding nominating modal
      let groupData = tblData.find(table =>
        table.seats.some(seat => seat.participant_email === profileData?.email)
      );


      let payload = {
        sub_type: "select_group_leader_each_GM",
        type: "case_study",
        room_id: sessionId,
        activity_id: activityData?.activity_id, // Add correct variable if available
        activityData: [
          {
            selectedParticipant: nominee,
            whoSelected: profileData?.email
          }
        ],
        timestamp: new Date()
      }
      userInfoHandler.current.sendMessage(JSON.stringify(payload));
      setModalMode(undefined);
    } else {

    }
  };
  const OkayGroupleader = () => {
    if (canTransfer) {
      if (!userInfoHandler.current) {
        userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
      }
      let payload = {
        sub_type: 'select_group_leader_each_GM',
        type: 'case_study',
        room_id: sessionId,
        activityData: {
          selectedMail: profileData?.email,
          selectedName: profileData?.name,
          table_name: tblData?.table_name,
        },
        timestamp: new Date(),
      };
      userInfoHandler.current.sendMessage(JSON.stringify(payload));
      setCanTransfer(false);
    }
    setModalMode(undefined);
    // setJustBecameGroupLeader(false);
  };

  useEffect(() => {
    if (modalMode === 'WHEN_GROUP_IS_PRESENTING') {
      roomClient.consumerResumeAllAudio();
    } else if (modalMode === 'SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS' && manuallySelected) {
      console.log('manuallySelected bye', manuallySelected);

      roomClient.consumerMuteParticipantByGroup(manuallySelected, 'trainer@vtt');
    }
  }, [modalMode])

  const updateSessionMetaInfo = async () => {
    let objBody = {
      sessionSegmanetId: session_id,
      type: 'VOLUNTEERING',
      traineeList: [profileData?.id]
    };
    const response: any = await axiosInstance.post(
      "trainer/update_session_meta_info",
      objBody
    );
    // postDataWithToken(objBody, mobile_siteConfig.MOB_UPDATE_SESSION_META_INFO)
    //     .then((res: any) => {
    //         const { response } = res;
    //         if (response.data && typeof response.data == 'object') { } else { }
    //     })
    //     .catch((error: any) => { console.log(error) });
  }

  const EndPresentation = () => {
    setHideOurDraggableView(false);
    userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);

    // setModalMode('WHEN_GROUP_IS_PRESENTING');
    var obj1 = {
      seat_number: csSelectedTraineeForPresentation?.seat_number,
      participant_id: csSelectedTraineeForPresentation?.participant_id,
      participant_name: csSelectedTraineeForPresentation?.participant_name,
      participant_email: csSelectedTraineeForPresentation?.participant_email,
      profilePhoto: 'null'
    }

    userInfoHandler.current.sendMessage(
      JSON.stringify({
        type: "case_study",
        sub_type: "launch_presentation_screen",
        room_id: session_id,
        activityData: {
          TableName: "Group 1",
          action: "end_own_presentation",
          role: "case_study",
          trainee: obj1
        }
      })
    );



  }

  const getTableName = async (data: any, showModal: boolean = false) => {
    data?.forEach((tableData: any, i: any) => {
      tableData?.seats?.map((v1: any, i1: any) => {
        let item = userToParticipantConverter(v1);
        // assign the updated value.
        tableData.seats[i1] = item;
        if (item?.participant_email?.toLowerCase() == profileData?.email?.toLowerCase()) {
          console.log('unspotlight:::::::::::::::1a', tableData?.case_url)
          setTblDataSnap(tableData);
          setTblData(tableData);
          onBrief(tableData?.case_url) // to show brief
          getGroupLeader(tableData, showModal);
        }
      });
    });
  };

  const startGroupPresentation = () => {
    console.log('presentationOrder:::::::::::::', csSelectedTraineeForPresentation)
    userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);


    var obj1 = {
      seat_number: csSelectedTraineeForPresentation?.seat_number,
      participant_id: csSelectedTraineeForPresentation?.participant_id,
      participant_name: csSelectedTraineeForPresentation?.participant_name,
      participant_email: csSelectedTraineeForPresentation?.participant_email,
      profilePhoto: 'null'
    }

    userInfoHandler.current.sendMessage(
      JSON.stringify({
        type: 'case_study',
        sub_type: 'launch_presentation_screen',
        room_id: sessionId,
        activityData: {
          TableName: presentationOrder?.groupName,
          action: 'start_own_presentation',
          role: 'case_study',
          trainee: obj1
        }
      })
    );

    setHideOurDraggableView(true);
    setIsIamRepresentingGroup(true);

  };

  const getGroupName = (groupName: string) => {
    // console.log('groupName::::', groupName)
    let grpName = '';
    if (groupName && typeof groupName == typeof '') {
      const seq = groupName?.split(' ');
      if (seq.length > 1) {
        grpName = 'Group ' + seq[1]
      }
    }
    return grpName;
  }

  const startManuallyPresentation = () => {
    userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);


    let obj1 = {};
    const isEmailMatched = manuallySelected?.seats.filter((item) => {
      if (item.participant_email === profileData?.email) {
        return item;
      }
    });
    console.log(isEmailMatched, "isEmailMatched")
    if (isEmailMatched[0].participant_email) {
      obj1 = {
        seat_number: isEmailMatched?.seat_number,
        participant_id: isEmailMatched?.participant_id,
        participant_name: isEmailMatched.participant_name,
        participant_email: isEmailMatched?.participant_email,
        profilePhoto: 'null'
      };
    }
    console.log(obj1, "selectedParticipant")

    userInfoHandler.current.sendMessage(
      JSON.stringify({
        type: 'case_study',
        sub_type: 'launch_presentation_screen',
        room_id: session_id,
        activityData: {
          TableName: manuallySelected?.table_name,
          action: 'start_own_presentation',
          role: 'case_study',
          trainee: isEmailMatched[0]
        }
      })
    );
    setHideOurDraggableView(true);
    setIsIamRepresentingGroup(true);
  };

  const handleEndPresentation = () => {
    userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
    let payload = {
      sub_type: csSubtype?.END_PRESENTATION,
      type: socketMessageType?.CASE_STUDY,
      room_id: session_id,
      timestamp: new Date()
    }
    userInfoHandler.current.sendMessage(JSON.stringify(payload));
    roomClient.disableShare() // stop sharing user's screen
    setModalMode(undefined)
  }


  const handleVideoCallResponse = (response: string) => {
    userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
    let payload = {
      type: socketMessageType?.CASE_STUDY,
      sub_type: csSubtype?.PVT_VID_REQUEST_RESPONSE,
      activityData: {
        participantRes: response,
        participant_email: profileData?.email,
        currentGroup: tblData?.table_name
      },
      room_id: sessionId,
      whoIsAsking: whoIsAsking,
      timestamp: new Date()
    }
    userInfoHandler.current.sendMessage(JSON.stringify(payload));
    setModalMode(undefined)
  }

  const onPreparationComplete = () => {
    if (presentaionType == 'case_url' && !fileToPresent) {
      return
    }
    setModalMode(undefined)
    showViewCaseTitle(true)
    setShowStartPresentation(true)
  }

  const userToParticipantConverter = (user: { id: number; participant_id: number; name: string; participant_name: string; email: string; participant_email: string; }) => {
    if (user.hasOwnProperty('id')) {
      user['participant_id'] = user.id;
    }
    if (user.hasOwnProperty('name')) {
      user['participant_name'] = user.name;
    }
    if (user.hasOwnProperty('email')) {
      user['participant_email'] = user.email;
    }
    console.log('returning user', user)
    return user;
  }

  const inExistingGroup = (tables: any[]) => {
    if (tables?.length > 0) {
      getTableName(tables)
      console.log("table 1")
    }
  }

  const getGroupLeader = (v: any, showModal: boolean = false) => {
    let gl = v?.seats?.find((e: any) => e?.group_leader)
    setGroupleader(gl);
    if (showModal && gl?.participant_name) {
      if (gl?.participant_email == profileData?.email) {
        setCanTransfer(false)
        setModalMode(csModalType?.YOUSELECTEDGL)
        console.log("True 2")
      }
      else {
        setRandomlySelected(gl?.participant_name)
        setModalMode(csModalType.RANDOMLYSELECTED)
      }
    }
  };
  const selectVolunteerFirst = () => {
    userInfoHandler.current = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
    let group_leader = groupleader && Object.keys(groupleader).length > 0 ? true : false;
    let myTable
    if (profileData?.email) {
      tblData.map((data, index) => {
        data.seats.map((subData, subIndex) => {
          if (subData.participant_email === profileData?.email) {
            return myTable = tblData[index];
          }
        })
      })
    }
    console.log(myTable, "myTable");

    let user_data = {
      userEmail: profileData?.email,
      userName: profileData?.name,
      seatingPlan: myTable,
      groupLeader: group_leader,
      timeStamp: Date.now(),
    };
    userInfoHandler.current.sendMessage(
      JSON.stringify({
        sub_type: 'system_request_accepted',
        type: 'launch_case_study',
        user_data: user_data,
        room_id: sessionId,
      })
    );

    //volunteer 2a:--to show the blank screen after accepting the request:---
    setModalMode(csModalType.NOMINATEPRESENTER);

  };

  useEffect(() => {
    console.log("csModalMode", modalMode)
  }, [modalMode])

  const renderModalContent = () => {
    switch (modalMode) {
      case csModalType.SETUP:
        return (
          <CsSetup roomClient={roomClient} />
        );
      case csModalType.READY_TO_PRESENT_ALL:
        return (
          <CsReadyToPresent
            showButton={true}
            onPress={selectVolunteerFirst}
          />
        );
      case csModalType.STARTPRESENTATION:
        return (
          <CsStartPresenter
            onPress={() => setModalMode('COMPLETEPREPARATION')}
            nominationType={groupleaderRef.current ? 'GroupLeader' : 'Group'}
          />
        );
      case csModalType.ENDWAIT:
        return (
          <CsEndWait />
        );
      case csModalType.COMPLETEPREPARATION:
        return (
          <CsCompletePreparation
            onDone={onPreparationComplete}
            setFileUrl={setFileToPresent}
            activePresentation={(pt: string) => setPresentaionType(pt)}
          />
        );
      case csModalType.WAIT:
        return (
          <CsWait />
        );
      case csModalType.COMMENCE:
        return (
          <CsCommence />
        );
      case csModalType.GROUPORDER:
        return (
          <CsGroupOrder
            data={groupOrder}
            tableData={tblData}
          />
        );
      case csModalType?.VIDEOCHATREQ:
        return (
          <CsVideoChatRequest
            name={whoIsAsking?.name}
            onYes={() => handleVideoCallResponse('yes')}
            onNo={() => handleVideoCallResponse('no')}
          />
        );
      // case csModalType?.YOUNEXT:
      //   return (
      //     <CsYouNext
      //       onClose={() => setModalMode(undefined)}
      //     />
      //   );
      // case csModalType.YOUSELECTEDGL:
      //   return (
      //     <CSGroupleader
      //       canTransfer={canTransfer}
      //       onTransfer={() => {
      //         setIsGlTransfer(true)
      //         setModalMode(csModalType?.NOMINATEGL)
      //       }}
      //       onOkay={OkayGroupleader}
      //       glmMode={GLMmode}
      //     />
      //   );
      // case csModalType.NOMINATEGL:
      //   return (
      //     <CSGroupleader
      //       canTransfer={canTransfer}
      //       onTransfer={() => {
      //         setIsGlTransfer(true)
      //         setModalMode(csModalType?.NOMINATEGL)
      //       }}
      //       onOkay={OkayGroupleader}
      //       glmMode={GLMmode}
      //     />
      //   );
      case 'SHOW_RANK_ORDER_FOR_PRESENTATION':
        return (
          <CsPresentationRankOrder
            showButton={true}
            onPress={() => {
              if (Number(presentationOrder?.rankOrder) === 0) {
                setModalMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');
                setPresentationOrder({
                  ...presentationOrder,
                  isOurGroupIsGoingToRepresent: true,
                });
                return;
              } else {
                setModalMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');
                setPresentationOrder({
                  ...presentationOrder,
                  isOurGroupIsGoingToRepresent: false,
                });
                return;
              }
            }}
            groupName={presentationOrder?.groupName}
            presentationRank={presentationOrder?.rankOrder}
          />
        );
      case 'SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS':
        return (
          <div className="flex flex-col items-center desktop:h-[50vh] h-[54vh] mobile:h-full relative px-4">
            <div className=" items-center flex justify-center mx-2 w-full my-5">
              <div className="bg-gray-900 max-w-xs w-full px-4 w-fit py-2 rounded-xl" style={{ borderRadius: "8px", backgroundColor: "#24272C", boxShadow: "-2px -2px 4px 0 rgba(255, 255, 255, 0.25), 2px 2px 4px 0 rgba(0, 0, 0, 0.25)", }}>
                <p className="text-white flex justify-center text-sm">
                  {manuallySelected?.group_name || manuallySelected?.table_name}
                </p>
              </div>
            </div>
            {isCsTimerActive && (
              <div className="absolute right-4 top-0 mobile:static mobile:mb-2 mobile:flex mobile:justify-center">
                <div className="bg-[rgba(33,32,37,0.8)] rounded-lg py-2 px-3 border border-[#545455] flex flex-row items-center justify-center gap-2">
                  <img src="./img/img4.png" alt="timer" className="w-4 h-4" />
                  <div className="flex flex-row items-center justify-center gap-1">
                    <span className="text-[#E9BE50] text-[10px]">{csMinutes}m</span>
                    <span className="text-[#E9BE50] text-[10px]">{csSeconds}s</span>
                  </div>
                </div>
              </div>)}
            <div className="w-full flex flex-col h-full justify-start my-5">
              <div className="grid grid-cols-3 tablet:grid-cols-3 laptop:grid-cols-4 mobile:grid-cols-2 text-white mobile:gap-y-4 mobile:gap-0 gap-2 m-2">
                {manuallySelected?.seats?.map((item) => (
                  <Box key={item.id}>
                    <TableElementNew
                      hideKebab={true}
                      elementStyle={{
                        borderWidth: 1,
                        borderRadius: 1,
                        borderColor: '#D3D3D3',
                        marginVertical: 0.4,
                      }}
                      onPress={() => { }}
                      userData={item}
                      isExpandedView={true}
                      groupLeaderEmail={undefined}
                    />
                  </Box>
                ))}
              </div>
            </div>

            {/* Start Presentation Button (centered at bottom) */}
            {profileData?.email === myEmailInPresentation?.participant_email && (
              <div className="w-full flex justify-center mb-10 z-[999]">
                <button
                  onClick={() => { startGroupPresentation() }}
                  className="flex items-center justify-center gap-2 px-2 border border-white text-white rounded-[43px] bg-gradient-to-br from-[#2F3339] to-[#15181C] shadow-custom-deep h-8 w-36 tablet:h-8 tablet:w-36 laptop:h-8 laptop:w-36 desktop:h-8 desktop:w-36 largescreen:h-8 largescreen:w-36 xxl:h-8 xxl:w-36"
                >
                  <Text as="span" size="2" weight="bold" className="text-s text-white">
                    Start Presentation
                  </Text>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_6083_4834)">
                      <path
                        d="M1.33203 1.33398H14.6654M5.33203 14.6673L7.9987 13.334M7.9987 13.334V11.334M7.9987 13.334L10.6654 14.6673M3.93203 11.334H12.0587C13.3254 11.334 13.992 10.6673 13.992 9.40065V1.33398H1.99203V9.40065C1.9987 10.6673 2.66536 11.334 3.93203 11.334Z"
                        stroke="white"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M5 7.33398L7.1 5.58065C7.26667 5.44065 7.48667 5.48065 7.6 5.66732L8.4 7.00065C8.51333 7.18732 8.73333 7.22065 8.9 7.08732L11 5.33398"
                        stroke="white"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_6083_4834">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>
            )}
          </div>
        )
      case 'SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS1':
        console.log('batchData?.participants:', presentationOrder?.presenterGroup?.seats);
        return (
          <div className="flex flex-col items-center desktop:h-[50vh] h-[54vh] mobile:h-full relative px-4">
            {isCsTimerActive && (
              <div className="absolute right-4 top-0 mobile:static mobile:mb-2 mobile:flex mobile:justify-center">
                <div className="bg-[rgba(33,32,37,0.8)] rounded-lg py-2 px-3 border border-[#545455] flex flex-row items-center justify-center gap-2">
                  <img src="./img/img4.png" alt="timer" className="w-4 h-4" />
                  <div className="flex flex-row items-center justify-center gap-1">
                    <span className="text-[#E9BE50] text-[10px]">{csMinutes}m</span>
                    <span className="text-[#E9BE50] text-[10px]">{csSeconds}s</span>
                  </div>
                </div>
              </div>)}
            <div className="w-full flex flex-col h-full justify-start my-5">
              <div className="grid grid-cols-3 tablet:grid-cols-3 laptop:grid-cols-4 mobile:grid-cols-2 text-white mobile:gap-y-4 mobile:gap-0 gap-2 m-2">
                {manuallySelected?.seats?.map((item) => (
                  <Box key={item.id}>
                    <TableElementNew
                      hideKebab={true}
                      elementStyle={{
                        borderWidth: 1,
                        borderRadius: 1,
                        borderColor: '#D3D3D3',
                        marginVertical: 0.4,
                      }}
                      onPress={() => { }}
                      userData={item}
                      isExpandedView={true}
                      groupLeaderEmail={undefined}
                    />
                  </Box>
                ))}
              </div>
            </div>

            {/* Start Presentation Button (centered at bottom) */}
            {profileData?.email === myEmailInPresentation?.participant_email && (
              <div className="w-full flex justify-center mb-10 z-50">
                <button
                  onClick={() => { startManuallyPresentation() }}
                  className="
               flex items-center justify-center gap-2 px-2
               border border-white text-white rounded-[43px]
               bg-gradient-to-br from-[#2F3339] to-[#15181C]
               shadow-custom-deep
         
               h-8 w-36     
               tablet:h-8 tablet:w-36
               laptop:h-8 laptop:w-36
               desktop:h-8 desktop:w-36
               largescreen:h-8 largescreen:w-36
               xxl:h-8 xxl:w-36
             "
                >
                  <Text as="span" size="2" weight="bold" className="text-s text-white">
                    Start Presentation
                  </Text>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_6083_4834)">
                      <path
                        d="M1.33203 1.33398H14.6654M5.33203 14.6673L7.9987 13.334M7.9987 13.334V11.334M7.9987 13.334L10.6654 14.6673M3.93203 11.334H12.0587C13.3254 11.334 13.992 10.6673 13.992 9.40065V1.33398H1.99203V9.40065C1.9987 10.6673 2.66536 11.334 3.93203 11.334Z"
                        stroke="white"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M5 7.33398L7.1 5.58065C7.26667 5.44065 7.48667 5.48065 7.6 5.66732L8.4 7.00065C8.51333 7.18732 8.73333 7.22065 8.9 7.08732L11 5.33398"
                        stroke="white"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_6083_4834">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>
            )}
          </div>
          // <div className="flex flex-col items-center">
          //   <div className="grid grid-cols-2 gap-2">
          //     {manuallySelected?.seats?.map((item: any, index: number) => (
          //       <Box key={item.id}>
          //         <Box
          //           style={{
          //             height: '100px',
          //             width: '100px',
          //             borderWidth: '1px',
          //             borderRadius: '8px',
          //             borderColor: '#D3D3D3',
          //             margin: '30px 0 10px 0',
          //           }}
          //         >
          //           <TableElementNew
          //             hideKebab={true}
          //             elementStyle={{
          //               borderWidth: 1,
          //               borderRadius: 1,
          //               borderColor: '#D3D3D3',
          //               marginVertical: 0.4,
          //             }}
          //             onPress={() => { }}
          //             userData={item}
          //             isExpandedView={true}
          //             groupLeaderEmail={undefined}
          //           />
          //         </Box>
          //       </Box>
          //     ))}
          //   </div>
          //   {profileData?.email === myEmailInPresentation?.participant_email && (
          //     <Button
          //       onClick={() => {
          //         console.log('start presentation');
          //         modalMode === 'SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS1'
          //           ? startManuallyPresentation()
          //           : startGroupPresentation();
          //       }}
          //       className="bg-green-600 hover:bg-green-700 text-white font-bold text-sm py-3 px-4 rounded-full mt-8 border border-white"
          //     >
          //       Start Presentation
          //     </Button>
          //   )}
          // </div>
        );
      case 'WHEN_GROUP_IS_PRESENTING':
        return (
          <div className="relative flex flex-col items-center desktop:h-[50vh] h-[50vh] mobile:h-full w-full mobile:space-y-8">
            {/* Main content container */}
            <div
              className={`w-full overflow-hidden gap-2 ${allStream[presentationOrder?.traineeDetails?.participant_email] ? 'flex flex-col mobile:h-fit justify-center mobile:justify-between desktop:flex-row largescreen:flex-row laptop:flex-row' : 'flex flex-col'} tablet:flex-1`}

            >
              {/* PeerView (Left side) */}
              {allStream[presentationOrder?.traineeDetails?.participant_email] && (
                <div className="mobile:w-full h-fit mobile:h-fit w-full max-w-5xl laptop:w-1/2 border border-[rgba(91,93,107,1)] flex items-center justify-center rounded-[1.5vh] overflow-hidden">
                  <div className="w-full h-full  rounded-[1.5vh] overflow-hidden relative">
                    <PeerView
                      caller="TableElement"
                      logicalMute={false}
                      style={{ height: 'mobile:h-[60vh]', width: '100%', position: 'relative', ObjectFit: 'cover' }}
                      streamURL={allStream[presentationOrder?.traineeDetails?.participant_email]}
                      peerEmail={presentationOrder?.traineeDetails?.participant_email}
                      allStream={undefined}
                      micIcon={true}
                      isExpandedView={false}
                      userDatax={presentationOrder?.traineeDetails}
                      height={390}
                    />
                  </div>
                </div>
              )}

              {/* Table grid (Right side) */}
              <div
                className={`mobile:w-full largescreen:max-h-[50vh]  w-fit ${allStream[presentationOrder?.traineeDetails?.participant_email] ? 'laptop:w-1/2' : ''
                  } h-fit overflow-y-auto custom-scrollbar`}
              >
                <div className="h-full overflow-y-auto pr-2">
                  <div
                    className={`${allStream[presentationOrder?.traineeDetails?.participant_email] ? 'grid grid-cols-1' : 'grid grid-cols-6'} tablet:grid-cols-3 laptop:grid-cols-4 gap-2 m-2 text-white mobile:flex mobile:overflow-x-auto mobile:gap-4 mobile:px-2 mobile:pb-2 mobile:grid-cols-none mobile:grid-rows-none`}
                  >
                    {manuallySelected?.seats?.map((item) => {
                      if (item?.participant_email === removedEmail) return null;
                      return (
                        <div key={item.participant_id}>
                          <TableElementNew
                            elementStyle={{
                              borderWidth: 1,
                              borderRadius: 1,
                              borderColor: '#D3D3D3',
                              marginVertical: 0.4,
                            }}
                            onPress={() => { }}
                            userData={item}
                            isExpandedView={true}
                            hideKebab={true}
                            groupLeaderEmail={undefined}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

            {/* Fixed End Presentation Button */}
            {profileData?.email === removedEmail && (
              // <div className="absolute bottom-0 w-full flex justify-center pb-2">
              //     <button
              //         onClick={() => {
              //             EndPresentation();
              //         }}
              //         className="bg-[rgba(224,71,37,1)] h-[5.5vh] w-[40vw] flex items-center justify-center rounded-[2.75vh] border-[1px] border-white"
              //     >
              //         <Text as="span" size="2" weight="bold" className="text-white">
              //             End Presentation
              //         </Text>
              //     </button>
              // </div>
              <div className=" mobile:static absolute -bottom-10 w-full flex justify-center mb-10 z-[999]">
                <button
                  onClick={() => {
                    EndPresentation();
                  }}
                  className="
                flex items-center justify-center gap-2 px-2
                border border-white text-white rounded-[43px]
                bg-gradient-to-br from-[#2F3339] to-[#15181C]
                shadow-custom-deep
          
                h-8 w-36     
                tablet:h-8 tablet:w-36
                laptop:h-8 laptop:w-36
                desktop:h-8 desktop:w-36
                largescreen:h-8 largescreen:w-36
                xxl:h-8 xxl:w-36
              "
                >
                  <Text as="span" size="2" weight="bold" className="text-s text-white">
                    Stop Presentation
                  </Text>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_6083_6290)">
                      <path d="M14.6654 1.83398H1.33203C1.0587 1.83398 0.832031 1.60732 0.832031 1.33398C0.832031 1.06065 1.0587 0.833984 1.33203 0.833984H14.6654C14.9387 0.833984 15.1654 1.06065 15.1654 1.33398C15.1654 1.60732 14.9387 1.83398 14.6654 1.83398ZM11.112 14.894C11.0254 15.0673 10.8454 15.1673 10.6654 15.1673C10.592 15.1673 10.512 15.1473 10.4454 15.114L7.9987 13.894L5.55203 15.114C5.48536 15.1473 5.40536 15.1673 5.33203 15.1673C5.15203 15.1673 4.97203 15.0673 4.88536 14.894C4.85479 14.8351 4.83639 14.7707 4.83127 14.7046C4.82616 14.6385 4.83443 14.572 4.85558 14.5091C4.87674 14.4463 4.91036 14.3883 4.95442 14.3388C4.99848 14.2892 5.05209 14.249 5.11203 14.2207L7.4987 13.0273V11.334H8.4987V13.0273L10.8854 14.2207C11.1387 14.3407 11.2387 14.6407 11.112 14.894Z" fill="#E9BE50" />
                      <path d="M2 1.33398V9.40065C2 10.6673 2.66667 11.334 3.93333 11.334H12.0667C13.3333 11.334 14 10.6673 14 9.40065V1.33398H2ZM11.32 5.72065L9.22 7.47398C9.02667 7.63398 8.78 7.70065 8.54667 7.66065C8.30667 7.62065 8.1 7.47398 7.97333 7.26065L7.27333 6.09398L5.32 7.72065C5.22667 7.80065 5.11333 7.83398 5 7.83398C4.89665 7.83461 4.79564 7.80319 4.71088 7.74404C4.62612 7.6849 4.56177 7.60095 4.52668 7.50373C4.49159 7.40651 4.4875 7.30081 4.51495 7.20117C4.54241 7.10153 4.60007 7.01284 4.68 6.94732L6.78 5.19398C6.97333 5.03398 7.22 4.96732 7.45333 5.00732C7.69333 5.04732 7.9 5.19398 8.02667 5.40732L8.72667 6.57398L10.68 4.94732C10.7307 4.90506 10.7892 4.87324 10.8522 4.85371C10.9153 4.83417 10.9815 4.82731 11.0472 4.8335C11.1129 4.8397 11.1767 4.85884 11.235 4.88982C11.2932 4.92079 11.3448 4.96299 11.3867 5.01398C11.56 5.22732 11.5333 5.54065 11.32 5.72065Z" fill="#E9BE50" />
                    </g>
                    <defs>
                      <clipPath id="clip0_6083_6290">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>
            )}
          </div>
          // <div className="relative flex flex-col items-center  h-[50vh]  mobile:h-full w-full mobile:space-y-8">
          //    <div
          //                   className={`w-full overflow-hidden ${allStream[presentationOrder?.traineeDetails?.participant_email] ? 'flex flex-col mobile:h-fit justify-center mobile:justify-between largescreen:flex-row laptop:flex-row' : 'flex flex-col'} tablet:flex-1`}

          //               ></div>
          //   {/* <div className="absolute top-0 w-96 bg-[rgba(33,32,37,0.8)] rounded-lg py-2 px-4 border border-[rgba(84,84,85,1)] flex items-center justify-center z-50">
          //     <Text className="text-yellow-500 font-bold text-xs">
          //       Case Discussion & Presentation in progress
          //     </Text>
          //     <div className="w-3" />
          //     <div className="h-3 w-3 rounded-full bg-green-600 border border-yellow-500" />
          //   </div> */}
          //   <div className="h-80 w-[92vw] border border-[rgba(91,93,107,1)] rounded-xl overflow-hidden my-2 flex items-center justify-center">
          //       {allStream[presentationOrder?.traineeDetails?.participant_email] && (
          //         <PeerView
          //           caller="TableElement"
          //           logicalMute={false}
          //           style={{ flex: 1, height: '100%', width: '100%' }}
          //           streamURL={allStream[presentationOrder?.traineeDetails?.participant_email]}
          //           peerEmail={presentationOrder?.traineeDetails?.participant_email}
          //           allStream={undefined}
          //           micIcon={true}
          //           isExpandedView={false}
          //           userDatax={undefined}
          //         />
          //       )}
          //   </div>
          //   <div className="grid grid-cols-2 gap-2">
          //     {manuallySelected?.seats?.map((item: any, index: number) => {
          //       if (item?.email === removedEmail) return null;
          //       if (item?.participant_email !== presentationOrder?.traineeDetails?.participant_email) {
          //         return (
          //           <TableElementNew
          //             key={item.id}
          //             elementStyle={{
          //               borderWidth: 1,
          //               borderRadius: 1,
          //               borderColor: '#D3D3D3',
          //               marginVertical: 0.4,
          //             }}
          //             onPress={() => { }}
          //             userData={item}
          //             isExpandedView={true}
          //             hideKebab={true}
          //             groupLeaderEmail={undefined}
          //           />
          //         );
          //       }
          //       return null;
          //     })}
          //   </div>
          //   {profileData?.email === removedEmail && (
          //     <div className=" mobile:static absolute -bottom-10 w-full flex justify-center">
          //       <button
          //         onClick={() => {
          //           EndPresentation();
          //         }}
          //         className="
          //           flex items-center justify-center gap-2 px-2
          //           border border-white text-white rounded-[43px]
          //           bg-gradient-to-br from-[#2F3339] to-[#15181C]
          //           shadow-custom-deep

          //           h-8 w-36     
          //           tablet:h-8 tablet:w-36
          //           laptop:h-8 laptop:w-36
          //           desktop:h-8 desktop:w-36
          //           largescreen:h-8 largescreen:w-36
          //           xxl:h-8 xxl:w-36
          //         "
          //       >
          //         <Text as="span" size="2" weight="bold" className="text-s text-white">
          //           Stop Presentation
          //         </Text>
          //         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          //           <g clip-path="url(#clip0_6083_6290)">
          //             <path d="M14.6654 1.83398H1.33203C1.0587 1.83398 0.832031 1.60732 0.832031 1.33398C0.832031 1.06065 1.0587 0.833984 1.33203 0.833984H14.6654C14.9387 0.833984 15.1654 1.06065 15.1654 1.33398C15.1654 1.60732 14.9387 1.83398 14.6654 1.83398ZM11.112 14.894C11.0254 15.0673 10.8454 15.1673 10.6654 15.1673C10.592 15.1673 10.512 15.1473 10.4454 15.114L7.9987 13.894L5.55203 15.114C5.48536 15.1473 5.40536 15.1673 5.33203 15.1673C5.15203 15.1673 4.97203 15.0673 4.88536 14.894C4.85479 14.8351 4.83639 14.7707 4.83127 14.7046C4.82616 14.6385 4.83443 14.572 4.85558 14.5091C4.87674 14.4463 4.91036 14.3883 4.95442 14.3388C4.99848 14.2892 5.05209 14.249 5.11203 14.2207L7.4987 13.0273V11.334H8.4987V13.0273L10.8854 14.2207C11.1387 14.3407 11.2387 14.6407 11.112 14.894Z" fill="#E9BE50" />
          //             <path d="M2 1.33398V9.40065C2 10.6673 2.66667 11.334 3.93333 11.334H12.0667C13.3333 11.334 14 10.6673 14 9.40065V1.33398H2ZM11.32 5.72065L9.22 7.47398C9.02667 7.63398 8.78 7.70065 8.54667 7.66065C8.30667 7.62065 8.1 7.47398 7.97333 7.26065L7.27333 6.09398L5.32 7.72065C5.22667 7.80065 5.11333 7.83398 5 7.83398C4.89665 7.83461 4.79564 7.80319 4.71088 7.74404C4.62612 7.6849 4.56177 7.60095 4.52668 7.50373C4.49159 7.40651 4.4875 7.30081 4.51495 7.20117C4.54241 7.10153 4.60007 7.01284 4.68 6.94732L6.78 5.19398C6.97333 5.03398 7.22 4.96732 7.45333 5.00732C7.69333 5.04732 7.9 5.19398 8.02667 5.40732L8.72667 6.57398L10.68 4.94732C10.7307 4.90506 10.7892 4.87324 10.8522 4.85371C10.9153 4.83417 10.9815 4.82731 11.0472 4.8335C11.1129 4.8397 11.1767 4.85884 11.235 4.88982C11.2932 4.92079 11.3448 4.96299 11.3867 5.01398C11.56 5.22732 11.5333 5.54065 11.32 5.72065Z" fill="#E9BE50" />
          //           </g>
          //           <defs>
          //             <clipPath id="clip0_6083_6290">
          //               <rect width="16" height="16" fill="white" />
          //             </clipPath>
          //           </defs>
          //         </svg>
          //       </button>
          //     </div>
          //     // <Button
          //     //   onClick={() => EndPresentation()}
          //     //   className="bg-red-600 hover:bg-red-700 text-white font-bold text-sm py-3 px-4 rounded-full mt-2 border border-white"
          //     // >
          //     //   End Presentation
          //     // </Button>
          //   )}
          // </div>
        );
      case 'MANUALLY_PRESENTER_SCREEN':
        return (
          <AsktoPresentCS
            showButton={true}
            onPress={() => setModalMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS1')}
            groupName={presentationOrder?.groupName}
            presentationRank={presentationOrder?.rankOrder}
          />
        );
      case 'OPEN_CLASS_INTERACTION_IN_PROGRESS':
        return (
          <div className="h-full mobile:mt-0">
            {/* {isCsTimerActive && (
              <div className="absolute right-4 top-0 mobile:static mobile:mb-2 mobile:flex mobile:justify-center">
                <div className="bg-[rgba(33,32,37,0.8)] rounded-lg py-2 px-3 border border-[#545455] flex flex-row items-center justify-center gap-2">
                  <img src="./img/img4.png" alt="timer" className="w-4 h-4" />
                  <div className="flex flex-row items-center justify-center gap-1">
                    <span className="text-[#E9BE50] text-[10px]">{csMinutes}m</span>
                    <span className="text-[#E9BE50] text-[10px]">{csSeconds}s</span>
                  </div>
                </div>
              </div>)} */}
            <OpenClassInteraction roomClient={roomClient} tableDetails={batchData?.participants} />
          </div>
        );
      default:
        return null;
    }
  };


  const renderOpenClassInteraction = () => {
    let _allParticipants = batchData?.participants;

    if (_allParticipants?.length <= 2) {
      return (
        <div className="flex flex-col h-full w-full">
          {_allParticipants?.map((v: any, i: number) => (
            <div key={i} className="flex-1 relative">
              <PeerView
                caller="CaseStudy"
                logicalMute={false}
                style={{ flex: 1, height: '100%', width: '100%' }}
                streamURL={allStream[v?.email]}
              />
              <ParticipantNew
                isVideoOn={allStream[v?.userData?.email || v?.userData?.participant_email] ? true : false}
                userData={v}
                name={v?.participant_name}
                id={v?.participant_id}
                profilePhoto={v?.profilePhoto}
                size="5"
                radius="small"
                kebab={true}
                video="yes"
                audio="yes"
                width={188}
                height={102}
                streamArray={allStream[v?.email || v?.participant_email]}
              />
              <div className="absolute top-0 left-0 p-2">
                <Text className="text-white font-[Lato-Regular] text-sm bg-[rgba(0,0,0,0.5)] px-2 py-1 rounded">
                  {v?.participant_name}
                </Text>
              </div>
            </div>
          ))}
        </div>
      );
    } else {
      return (
        <div className="grid grid-cols-2 gap-1 h-full w-full">
          {_allParticipants?.map((v: any, i: number) => (
            <div
              key={i}
              className="relative"
              style={{ height: boxSize.height, width: boxSize.width }}
            >
              <PeerView
                caller="CaseStudy"
                logicalMute={false}
                style={{ flex: 1, height: '100%', width: '100%' }}
                streamURL={allStream[v?.email]}
              />
              <ParticipantNew
                isVideoOn={allStream[v?.userData?.email || v?.userData?.participant_email] ? true : false}
                userData={v?.userData}
                name={v?.participant_name}
                id={v?.participant_id}
                profilePhoto={v?.profilePhoto}
                size="5"
                radius="small"
                kebab={true}
                video="yes"
                audio="yes"
                width={188}
                height={102}
                streamArray={allStream[v?.email || v?.participant_email]}
              />
              <div className="absolute top-0 left-0 p-2">
                <Text className="text-white font-[Lato-Regular] text-sm bg-[rgba(0,0,0,0.5)] px-2 py-1 rounded">
                  {v?.participant_name}
                </Text>
              </div>
            </div>
          ))}
        </div>
      );
    }
  }

  const renderPresentParticipent = () => {
    let _otherParticipents = tblData?.seats?.filter(
      (x: any) => x?.participant_email?.toLowerCase() !== profileData?.email?.toLowerCase()
    );
    return (
      <Box className="flex flex-wrap">
        {_otherParticipents?.map((v: any, i: number) => (
          <Box key={i} className="w-[25vw] h-[25vw]">
            <PeerView
              caller='GroupDiscussion'
              logicalMute={false}
              style={{ flex: 1, height: '100%', width: '100%' }}
              streamURL={otherStream[v?.participant_email]}
            />
          </Box>
        ))}
        <Box className="flex flex-wrap">
          {['share_whiteboard', 'case_url', 'share_screen']?.includes(presentaionData?.activePresentation) &&
            presentaionData?.presentNominee !== profileData?.email && (
              <PeerView
                caller='GroupDiscussion'
                logicalMute={false}
                style={undefined}
                streamURL={allStream[presentaionData?.presentNominee]}
              />
            )}
          <Box><Trainer name={trainer?.fullname} trainerTableName="On Table 1" /></Box>
          <Box><MyPeerView /></Box>
        </Box>
      </Box>
    );
  };

  const renderPresentationInGroups = () => {
    if (spotlightTable?.seats?.length > 0) {
      console.log('spotlight Table::::::::::::::::0', spotlightTable);
      return (
        <div className="flex flex-1 items-center justify-center my-4">
          <CSTable
            roomClient={roomClient}
            isTrainerPresent={isTrainerPresent}
            tableData={[spotlightTable]}
            name={spotlightTable?.table_name}
            users={spotlightTable}
          />
        </div>

      );
    } else {
      console.log('spotlight Table::::::::::::::::1', tblData);
      let newTblData1: any[];
      if (typeof tblData === 'object' && Array.isArray(tblData)) {
        newTblData1 = tblData;
      } else if (typeof tblData === 'object' && tblData !== null) {
        console.log('newDatax is an object', tblData);
        newTblData1 = [tblData];
      } else {
        console.log('newData is neither an object nor an array');
        newTblData1 = [];
      }

      return (
        <div className="flex flex-1 flex-col relative items-center justify-center my-4">
          {isCsTimerActive && (<div className="w-full mr-4  mobile:mb-2 flex mobile:justify-center justify-end">
            <div className="bg-[rgba(33,32,37,0.8)] rounded-lg py-2 px-3 border border-[#545455] flex flex-row items-center justify-center gap-2">
              <img src="./img/img4.png" alt="timer" className="w-4 h-4" />
              <div className="flex flex-row items-center justify-center gap-1">
                <span className="text-[#E9BE50] text-[10px]">{csMinutes}m</span>
                <span className="text-[#E9BE50] text-[10px]">{csSeconds}s</span>
              </div>
            </div>
          </div>)}
          <CSTable
            roomClient={roomClient}
            session={sessionId}
            showExpand={(v: boolean) => {
              showViewCaseTitle(v);
              setShowMyfeed(v);
            }}
            isTrainerPresent={isTrainerPresent}
            tableData={newTblData}
            name={tblData?.table_name}
            users={newTblData}
            gl={groupLeaderUpdated}
          />
        </div>
      );
    }
  }

  const handleOnMessage = async (_data: any) => {
    const data = JSON.parse(_data);
    if (data.type === 'live_session'
      && data.sub_type === 'time_extend') {

      // prevent double execution
      if (lastExtendEventIdRef?.current === data.timestamp) return;
      lastExtendEventIdRef.current = data.timestamp;

      if (data.step === 'case_study') {
        setExtendedTime({ visible: true, time: data.extend_time });
        setTimeout(() => setExtendedTime({ visible: false, time: 0 }), 5000);
        setCSMinutes(prev => prev + data.extend_time);
      }

      if (data.step === 'Presentation') {
        setCSMinutes(prev => prev + data.extend_time);
      }
    }
    if (data.type == 'live_session' && data.sub_type == 'time_extend' && data.step == 'case_study') {
      setExtendedTime({
        visible: true,
        time: data.extend_time
      })
      setTimeout(() => {
        setExtendedTime({
          visible: false,
          time: 0
        })
      }, 5000);
    }
    // else if (data.type === 'live_session' && data.sub_type === 'handle_trainer_response_OnExtend'){
    //   if(data?.activityData?.isTimeExtend){
    //   setCSMinutes((prev) => prev + data?.activityData?.extendTime);
    //   }
    // }
    if (data.type === 'case_study') {
      if (data?.sub_type === 'trainer_joined_group') {
        const isMyEmailParticipant = data.participants.some(
          (participant: any) => participant.participant_email === profileData.email
        );
        const trainerDetail = data.participants.find(
          (participant: any) => participant.participant_email === 'trainer@vtt'
        );
        if (trainerDetail) {
          trainerDetail.table_name = data.table_name;
        }
        if (isMyEmailParticipant) {
          setTblData((prevData: any) => {
            return {
              ...prevData,
              seats: [...prevData.seats, trainerDetail],
            }
          });
        }
        setIsTrainerPresent(trainerDetail);
        dispatch(updateLiveStreamSettings({
          trainerJoinedtable: {
            isTrainerPresent: true,
            groupName: data.table_name,
            TrainerJoinTableData: data.participants
          }
        }))
      } else if (data?.sub_type === 'trainer_leave_group') {
        const myGroup = data.participants.some(
          (participant: any) => participant.participant_email === profileData.email
        );
        if (myGroup) {
          const newSeats = data.participants.filter(
            (participant: any) => participant.participant_email !== 'trainer@vtt'
          );
          setTblData((prevData: any) => {
            return { ...prevData, seats: newSeats };
          });
        }
        setIsTrainerPresent({});
        dispatch(updateLiveStreamSettings({
          trainerJoinedtable: {
            isTrainerPresent: false,
            groupName: '',
            TrainerJoinTableData: []
          }
        }))
      }
      if (data?.sub_type === "launch_presentation_screen") {
        setModalMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS')
      }

      else if (data.sub_type === 'launch_spotlight_screen') {
        console.log('unspotlight:::::::::::::::3', data?.activityData)
        setTblData(data.activityData)
        setUnspotlight(false)
      }
      else if (data.sub_type === 'launch_un_spotlight_screen') {
        setUnspotlight(true)
      }
    }

    if (data.type === "case_study") {
      if (data.sub_type === "end_presentation") {
        setModalMode(undefined);
      }
    }

    if (data?.type === 'launch_case_study') {
      if (data?.sub_type === "ask_group_to_present_presenation") {
        if (data?.groupGoingToPresent) {

          if (data?.step) {
            setModalMode("SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS")

          } else {
            const manualPresent = data?.groupGoingToPresent.seats.find((item) => item.participant_email === profileData?.email)
            if (profileData?.email === manualPresent?.participant_email) {
              // showPresentModal()
              setModalMode('MANUALLY_PRESENTER_SCREEN');
            }
          }
          setmanuallySelected(data.groupGoingToPresent);
          // setModalMode("SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS");

          showPresentModal()
        }
      }

      if (data?.sub_type === "ask_group_to_present_presenation" && data?.step == 'end_presentation') {
        setModalMode(false)
      }
    }
    if (data.sub_type === "selected_group_order") {
      // if (data?.step === "presention_by_order_started") {
      if (data.groupGoingToPresent) {
        setmanuallySelected(data?.groupGoingToPresent);
        // }
      }
    }
    if (data?.type == 'case_study' && data?.sub_type == 'reset_group_data') {
      setTimeout(() => {
        // console.log('OkDone::>>>')
        console.log('unspotlight:::::::::::::::4', data?.activityData?.table_data)
        setTblData(data?.activityData?.table_data);
        setTblDataSnap(data?.activityData?.table_data);
      }, 1500);
      return
    }
    if (data?.type === 'launch_case_study' && data?.sub_type === 'reset_group_data') {
      data.activityData.forEach((group) => {
        const hasGroupLeaderWithEmail = group.seats.some(seat => seat.group_leader && seat.participant_email === profileData.email);
        if (hasGroupLeaderWithEmail) {
          setShowModal(true);
          return; // Exit the loop if a group leader with email is found
        }
      });
    }
    if (data?.type === 'launch_case_study' && data?.sub_type === 'leader_individual') {
      setShowNominateModal(true)
    }
    if (data?.type === 'case_study' && data?.sub_type === 'leader_trainer_select') {
      data.activityData.case.forEach((group) => {
        const hasGroupLeaderWithEmail = group.seats.some(seat => seat.group_leader && seat.participant_email === profileData.email);
        if (hasGroupLeaderWithEmail) {
          setShowModal(true);
          return; // Exit the loop if a group leader with email is found
        }
      });
    }
    // if (data?.type === 'case_study' && data?.sub_type === 'leader_trainer_select') {
    //   const myGroup = data.activityData.case.find((group: any) =>
    //     group.seats.some((seat: any) => seat.participant_email === profileData?.email)
    //   );

    //   if (myGroup) {
    //     const leader = myGroup.seats.find((s: any) => s.group_leader);

    //     if (leader) {
    //       setGroupleader(leader);
    //       setGLMmode('trainer_leader_select');

    //       if (leader.participant_email === profileData?.email) {
    //         setCanTransfer(false);
    //         // setJustBecameGroupLeader(true);
    //         setModalMode(csModalType.YOUSELECTEDGL); // This triggers the crown modal
    //       } else {
    //         setMessageCxt({
    //           visible: true,
    //           message: `${leader.participant_name} is your Group Leader (selected by trainer)`
    //         });
    //         // setTimeout(() => setMessageCxt({ visible: false, message: '' }), 6000);
    //       }
    //     }
    //   }
    // }

    if (data?.type === 'case_study' && data?.sub_type === 'leader_nominated') {
      setgroupLeaderUpdated(data?.activityData.case)
      setModalMode(csModalType.COMMENCE)
      updateSessionMetaInfo()
      setTimeout(() => {
        setModalMode(undefined);
        showViewCaseTitle(true)
      });
    }


    if (data?.type == 'case_study' && data?.sub_type == 'launch_case_study') {
      setNewTableData(data.activityData.sittingArrangement)
      setNewTblData(data.activityData.case)
      setTblData(data.activityData.sittingArrangement)
      setModalMode(false)
      var allotedTime = data?.activityData?.alot_time;
      var presentationDuration = data?.activityData?.duration_presntation;
      presentationDurationRef.current = Number(presentationDuration);
      var presentationGroupData = data?.activityData?.case;
      console.log('setting time :::::::::::', allotedTime, presentationDuration);
      setCSMinutes(Number(allotedTime))
      setCSSeconds(0)
      setIsCsTimerActive(true);
      startTimer(Number(allotedTime))
      if (typeof presentationGroupData === 'object' && Array.isArray(presentationGroupData)) {
        console.log('newDatax is an array', presentationGroupData);
        var newData = presentationGroupData;
        setTblData(newData);
        setTblDataSnap(newData);

      } else if (typeof presentationGroupData === 'object') {
        console.log('newDatax is an object', presentationGroupData);
        var newData = [presentationGroupData];
        setTblData(newData);
        setTblDataSnap(newData);

      } else {
        console.log('newData is neither an object nor an array');
      }
    }

    if (data.type === "launch_case_study") {
      if (data.sub_type === "selected_group_order") {
        setIsCsTimerActive(false);

        setTimeout(() => {
          setCSMinutes(presentationDurationRef.current);
          setCSSeconds(0);
          setIsCsTimerActive(true);
        }, 50);

        if (data.step === 'change_presentation_to_next') {
          setModalMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');
        }
      }
    }

    if (data?.type == socketMessageType.CASE_STUDY && data?.sub_type == 'complete_case_study_set_up') {
      setNewTableData(data.activityData.sittingArrangement)
      setTblData(data.activityData.sittingArrangement)
      setModalMode(false)
      setModalMode(csModalType.COMMENCE);
      setTimeout(() => {
        setModalMode(undefined);
      }, 2000);
      return;
    }

    if (data?.sub_type == socketMessageSubType?.SPOTLIGHT_TABLE_SET) {
      setSpotlightTable(data?.activityData?.table)
      return
    }

    if (data?.sub_type == socketMessageSubType?.SPOTLIGHT_TABLE_UNSET) {
      setSpotlightTable({})
      return
    }
    console.log(data, "Check Data")
    if (data?.type == socketMessageType.SPLIT_ROOM) {
      // split group and set up table name and team leader name
      getTableName(data?.newGroups?.table);
      console.log("table 2")
      return
    }

    if (data?.sub_type == csSubtype.END_PRESENTATION) {
      setIsPresentationStarted(false)
      return
    }
    if (data?.sub_type == csSubtype?.SELECTED_GROUP_ORDER) {
      if (data?.activityData === "end_presentation") {
        // setIsPresentationStarted(false)
        // setModalMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');
        setModalMode(false);
        return
      }
      if (data?.step === "end_presentation") {
        // setIsPresentationStarted(false)
        setModalMode(false);
        return
      }
      if (data.sub_type === "end_presentation") {
        setModalMode(false);
      }
    }

    if (data?.sub_type == csSubtype.HANDLE_TRAINER_RESPONSE_ONEXTEND) {
      if (data?.activityData?.comingGroup?.group_name == tblDataRef?.current?.table_name) {
        if (data?.activityData?.comingGroup?.selected_nominee?.selectedNom_email == profileData?.email) {
          setModalMode(csModalType?.YOUNEXT)
        }
        else {
          setModalMode(csModalType?.YOUNEXT)
        }
      }
      return
    }

    if (data?.sub_type == csSubtype?.SELECT_GROUP_LEADER_EACH_GM && data?.activityData[0]?.selectedParticipant) {
    }

    // invite for private video chat
    if (data?.sub_type == csSubtype.ASK_FOR_VIDEO_CHAT && data?.activityData?.whomToInvite == profileData?.email) {
      setWhoIsAsking(data?.activityData?.whoIsInviting)
      setModalMode(csModalType?.VIDEOCHATREQ)
      return
    }

    if (data?.sub_type == csSubtype.ASK_FOR_VIDEO_CHAT && data?.activityData?.participant_email == 'yes') {
      setIsPrivateVideoChat(true)
      setPrivateVideoChatParticipents([
        data?.whoIsAsking,
        data?.activityData?.participant_email
      ])
      return
    }
    //
    if (data?.sub_type == csSubtype.LAUNCH_CASE_STUDY && !GLMmode) {
      // In existing groups
      if (data?.activityData?.select_the_participant_grouping == 1) {
        inExistingGroup(data?.activityData?.case)
      }
      setgroupLeaderUpdated(data?.activityData.case)
      setModalMode(csModalType.COMMENCE)
      // updateSessionMetaInfo()
      setTimeout(() => {
        setModalMode(undefined);
        showViewCaseTitle(true)
      }, 2000);
      return
    }

    // trainee is seeing popup to reqpresent group, for all group
    if (data?.sub_type == csSubtype.VOLUNTEER_FOR_CASE_STUDY) {
      setBriefMode("volunteer_mode")
      // show volunteer modal :: if group have leader to group leader else show to all participent
      if (groupleaderRef.current) {
        console.log('volunteer_for_case_study::::::::::::::::::1')
        if (groupleaderRef.current?.participant_email == profileData?.email) {

          console.log('volunteer_for_case_study::::::::::::::::::2')
          // show volunteer modal to team leader
          setModalMode(csModalType?.READY_TO_PRESENT_GROUP_LEADER);
          setModalMode(csModalType?.READY_TO_PRESENT_ALL);
        }
        else {

          console.log('volunteer_for_case_study::::::::::::::::::3')
          // show wait modal to other participent
          setModalMode(csModalType?.WAIT);
          setModalMode(csModalType?.READY_TO_PRESENT_ALL);
        }
      } else {
        // show volunteer modal to all participent
        console.log('volunteer_for_case_study::::::::::::::::::4')
        //volunteer 0:---
        setModalMode(csModalType?.READY_TO_PRESENT_ALL);
      }
      return
    }

    if (data?.sub_type == csSubtype.SELECTED_GROUP_ORDER) {
      if (data?.step === "presention_by_order_started") {
        setModalMode('SHOW_RANK_ORDER_FOR_PRESENTATION');
      }
      console.log('presentation :::::::::::::::::::!1');
      setBriefMode("order_presentation_mode");
      // Close presentation if already started
      if (isPresentationStarted) {
        console.log('presentation :::::::::::::::::::!2');
        setIsPresentationStarted(false);
      }

      if (data?.groupOrder?.length > 0) {
        console.log('presentation :::::::::::::::::::!3 length is greater than zero:::::::');

        const findParticipantByEmail = (email) => {
          for (var i = 0; i < data.groupOrder.length; i++) {
            var group = data.groupOrder[i];
            for (var j = 0; j < group.seats.length; j++) {
              if (group.seats[j].participant_email === email) {
                console.log('presentationOrder::::::::::::,,1', group.seats[j]);
                dispatch(csCaseStudyParticipants({ csSelectedTraineeForPresentation: group.seats[j] }))
                console.log('presentationOrder::::::::::::,,1b', group.seats[j]);
                return { groupName: group.group_name, index: i };
              }
            }
          }
          return null; // If participant not found
        }

        var participantEmail = profileData?.email;
        var result = findParticipantByEmail(participantEmail);
        if (result) {
          console.log("Participant found in group:", result.groupName, "at index:", result.index);
          const isOurGroupPresenting = result.groupName === data?.groupGoingToPresent;
          setPresentationOrder({
            ...presentationOrder,
            groupName: result.groupName,
            rankOrder: String(result.index),
            presenterGroup: data?.groupGoingToPresent,
            isOurGroupIsGoingToRepresent: isOurGroupPresenting,
          });
        } else {
          console.log("Participant not found.");
        }
        return;
      }

      // Nominees are not selected : nomination flow
      if (groupleaderRef.current) {
        if (groupleaderRef.current?.participant_email == profileData?.email) {
          // Show volunteer modal to team leader
          setModalMode(csModalType?.READY_TO_PRESENT_GROUP_LEADER);
        } else {
          // Show wait modal to other participant
          setModalMode(csModalType?.WAIT);
        }
      }
      //  else {
      //     // Show volunteer modal to all participant
      //     setModalMode(csModalType?.READY_TO_PRESENT_ALL);
      // }

      return;
    }

    if (data?.sub_type == csSubtype.ASK_GROUP_TO_PRESENT_PRESENATION) {
      if (data?.activity_data?.selected_nominee?.selectedNom_email == profileData?.email) {
        // trainee have to present
        setModalMode(csModalType?.STARTPRESENTATION)
      }
      return
    }

    if (data?.sub_type == csSubtype.ASK_GROUP_TO_PRESENT) {
      setBriefMode("verbally_mode")
      // nominees are not selected : nomination flow
      if (groupleaderRef.current) {
        if (groupleaderRef.current?.participant_email == profileData?.email) {
          // show volunteer modal to team leader
          setModalMode(csModalType?.READY_TO_PRESENT_GROUP_LEADER);
        }
        else {
          // show wait modal to other participent
          setModalMode(csModalType?.WAIT);
        }
      }
      // else {
      //     // show volunteer modal to all participent
      //     setModalMode(csModalType?.READY_TO_PRESENT_ALL);
      // }
    }

    if (data?.sub_type == csSubtype.INITIATE_SELECTED_GROUP_ORDER) {
      return
    }

    if (data?.sub_type == csSubtype.DRAG_SELECTED_GROUP_ORDER) {
      // re arrange group order

      // ignoring the current flow when trainer swap the presentation order:-->>>>>>>>
      // setGroupOrder([...data?.activityData?.groupOrderListByTrainer]);
      // setModalMode(csModalType?.GROUPORDER);
      return
    }

    if (data?.sub_type == csSubtype.SYSTEM_REQUEST_ACCEPTED && data?.nominatedParticipantData) {
      if (data?.nominatedParticipantData?.selectedNominee?.participant_email == profileData?.email) {

      }
      return
    }

    if (data?.type === 'launch_case_study' && data?.sub_type === 'system_request_accepted') {
      //setting users screen to blank from the same group:----
      // console.log('Hiii::::::::::::::::::::::ding 1', data?.user_data?.seatingPlan)
      // console.log('Hiii::::::::::::::::::::::ding 1', typeof (data?.user_data?.seatingPlan))

      var newDatax = data?.user_data?.seatingPlan;

      if (typeof newDatax === 'object' && Array.isArray(newDatax)) {
        // console.log('newDatax is an array');
        var newData = newDatax;
      } else if (typeof newDatax === 'object') {
        // console.log('newDatax is an object');
        var newData = [newDatax];
      } else {
        console.log('newData is neither an object nor an array');
      }


      const checkEmails = (email1, email2, newData) => {
        // console.log('checkIfOurGroupAcceptedTheEmail:::::::::::::::1', newData)
        for (let i = 0; i < newData.length; i++) {
          // console.log('checkIfOurGroupAcceptedTheEmail:::::::::::::::2', i)
          const group = newData[i];
          // console.log('checkIfOurGroupAcceptedTheEmail:::::::::::::::3', group);
          const seats = group?.seats;
          // console.log('checkIfOurGroupAcceptedTheEmail:::::::::::::::4', seats)
          let email1Found = false;
          let email2Found = false;
          if (seats.length > 0) {
            for (let j = 0; j < seats.length; j++) {
              // console.log('checkIfOurGroupAcceptedTheEmail:::::::::::::::5')
              const participant = seats[j];
              //
              if (participant.participant_email === email1) {
                // console.log('checkIfOurGroupAcceptedTheEmail:::::::::::::::6', email1)
                email1Found = true;
              }
              else if (participant.participant_email === email2) {
                // console.log('checkIfOurGroupAcceptedTheEmail:::::::::::::::7', email2)
                // return true;
                email2Found = true;
              }
            }
            if (email1Found === true) {
              if (email2Found == true) {
                return true;
              }
            }

            if (email2Found === true) {
              if (email1Found == true) {
                return true;
              }
            }
          }
        }
        return false;
      }


      // console.log('checkIfOurGroupAcceptedTheEmail:::::::::::0', profileData?.trainee_email, data?.user_data?.userEmail)
      if (profileData?.email !== undefined && data?.user_data?.userEmail !== undefined && tblDataSnap !== undefined) {

        var checkIfOurGroupAcceptedTheEmail = checkEmails(profileData?.email, data?.user_data?.userEmail, newData)
        // console.log('checkIfOurGroupAcceptedTheEmail', checkIfOurGroupAcceptedTheEmail)
        if (checkIfOurGroupAcceptedTheEmail) {
          setModalMode(csModalType.NOMINATEPRESENTER);
        } else {
          return
        }
      }

    }

    if (data?.sub_type == csSubtype.SELECTED_GROUP_ORDER && data?.activityData?.groupOrderListByTrainer?.length > 0) {
      setGroupOrder([...data?.activityData?.groupOrderListByTrainer]);
      setModalMode(csModalType?.GROUPORDER);
      return
    }

    if (data?.sub_type == csSubtype.INITIATE_SELECTED_GROUP_ORDER) {
      return
    }

    if (data?.sub_type == csSubtype?.OPEN_CLASS_INTERACTION) {
      // open class intereaction
      console.log('----------------------------------------------------------------true::')
      // setOpenClassInteraction(true)
      setModalMode('OPEN_CLASS_INTERACTION_IN_PROGRESS');
      setMinutes(data?.timeForOCI)
      setCSMinutes(data?.timeForOCI)
      setCSSeconds(0)
      setIsCsTimerActive(true)
      return
    }

    if (data?.sub_type == 'end_open_class_interaction') {
      setModalMode(false);
      // open class intereaction
      // setOpenClassInteraction(false)
      // setModalMode(undefined);
      //table view:-->>

      return
    }

    if (data?.sub_type == 'share_white_board') {
      // share white board
      setModalMode(undefined);
      return
    }

    if (data?.sub_type == csSubtype?.LAUNCH_PRESENTATION_SCREEN) {
      setCSMinutes(Number(presentationDuration));
      setCSSeconds(0);

      if (data?.activityData?.action === 'start_own_presentation' && data?.activityData?.trainee?.participant_email !== undefined) {
        console.log('start own presentation')

        setRemovedEmail(data?.activityData?.trainee?.participant_email);
        setModalMode('WHEN_GROUP_IS_PRESENTING');
        setPresentationOrder({
          ...presentationOrder,
          traineeDetails: data?.activityData?.trainee
        })
      }

      if (data?.activityData?.action === 'end_own_presentation' && data?.activityData?.trainee?.participant_email !== undefined) {
        console.log('end own presentation')
        setRemovedEmail(data?.activityData?.trainee?.participant_email);

        // check if the  data?.activityData?.trainee?.participant_email is in our group or not???
        console.log('tbldata::::::::::::::tblDAta:::::::', tblData);


        if (typeof tblData === 'object' && Array.isArray(tblData)) {
          var newData = tblData;
        } else if (typeof tblData === 'object') {
          var newData = [tblData];
        } else {
          console.log('newData is neither an object nor an array');
        }


        const checkEmails = (email1, email2, newData) => {
          for (let i = 0; i < newData.length; i++) {
            const group = newData[i];
            const seats = group?.seats;
            let email1Found = false;
            let email2Found = false;
            if (seats && seats.length > 0) {
              for (let j = 0; j < seats.length; j++) {
                const participant = seats[j];
                //
                if (participant.participant_email === email1) {
                  email1Found = true;
                }
                else if (participant.participant_email === email2) {
                  email2Found = true;
                }
              }
              if (email1Found === true) {
                if (email2Found == true) {
                  return true;
                }
              }

              if (email2Found === true) {
                if (email1Found == true) {
                  return true;
                }
              }
            }
          }
          return false;
        }



        if (profileData?.email !== undefined && data?.activityData?.trainee?.participant_email !== undefined && tblDataSnap !== undefined) {
          if (newData.length > 0) {
            var checkIfOurGroupAcceptedTheEmail = checkEmails(profileData?.email, data?.activityData?.trainee?.participant_email, newData)
            // console.log('checkIfOurGroupAcceptedTheEmail', checkIfOurGroupAcceptedTheEmail)
            if (checkIfOurGroupAcceptedTheEmail) {

              setModalMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');
              setPresentationOrder({
                ...presentationOrder,
                traineeDetails: data?.activityData?.trainee,
                isOurGroupIsGoingToRepresent: true
              })
            } else {
              setModalMode('SELECTION_OF_GROUP_REPRESENTATION_BY_PARTICIPANTS');
              setPresentationOrder({
                ...presentationOrder,
                traineeDetails: data?.activityData?.trainee,
                isOurGroupIsGoingToRepresent: false
              })
              return
            }
          }
        }

      }

    }

    if (data?.sub_type == csSubtype?.CASE_STUDY_SETUP && !GLMmodeRef.current) {
      if (data?.activityData?.isSetupProcess == true) {
        setModalMode(csModalType.ENDWAIT);
      }
      else if (data?.activityData?.isSetupProcess == false) {
        // setModalMode(undefined);
        setModalMode(csModalType.ENDWAIT);
      }
    }

    if (data?.sub_type == csSubtype.CONFIRM_EACH_GROUP_PICKS_GL) {
      const glSelectionData: any[] = data?.activityData?.selected_leader_each;
      const amIGL = glSelectionData?.find(item => item.email == profileData?.email || item.participant_email == profileData?.email)
      if (amIGL) {
        setGroupleader(amIGL);
        console.log('I am selected GL')
        // if I am part of the GL list notify that I have been selected.
        if (groupleaderRef?.current?.participant_email == profileData?.email || groupleaderRef?.current?.email == profileData?.email) {
          // If i was already GL, don't do anything.
          console.log('I was already GL. Not doing anything')
        } else {
          setModalMode(csModalType?.YOUSELECTEDGL);
          setCanTransfer(false);
        }
      } else {
        console.log('I am not selected GL')
        // tell that some X user has been nominated as GL.
        // const isGLUnChanged = glSelectionData.find(item => item.email == groupleaderRef?.current?.participant_email || item.participant_email == groupleaderRef?.current?.participant_email)
        // if(isGLUnChanged){
        //   console.log('GL is unchanged. Doing nothing');

        //   // if last GL and new GL for my group are same don't do anything
        // } else {
        // show that some X user is selected as GL table_name
        console.log('tblData?.table_name:::', tblDataRef.current?.table_name,)
        let myGroupGl = glSelectionData.find(selected => getGroupName(selected.table_name) == getGroupName(tblDataRef.current?.table_name));
        console.log('myGroupGl::::', myGroupGl)
        if (myGroupGl) {
          setGroupleader(myGroupGl);
          setMessageCxt({
            visible: true,
            message: `You have nominated and selected ${myGroupGl?.name || myGroupGl?.participant_name} as your Group Leader!`
          })
        }
        // }
      }
      return;
    }
  };

  if (isPresentationStarted && ['share_whiteboard', 'case_url', 'share_screen']?.includes(presentaionData?.activePresentation) && showFullscreen) {
    return (
      <Box className="flex-1">
        {presentaionData?.activePresentation === 'share_whiteboard' && (
          <Box className="flex-1">
            <iframe
              src={`https://vtt.atwpl.com/whiteboard/boards/${session_id}?disableInteraction=${presentaionData?.presentNominee === profileData?.email ? false : true
                }`}
              className="w-full h-full"
              allow="camera; microphone; fullscreen; display-capture"
            />
          </Box>
        )}
        {presentaionData?.activePresentation === 'case_url' && (
          <Box className="flex-1">
            {presentaionData?.fileUrl?.endsWith('.pdf') ? (
              <iframe src={presentaionData?.fileUrl} className="w-full h-full" />
            ) : (
              <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${presentaionData?.fileUrl}`}
                className="w-full h-full"
              />
            )}
          </Box>
        )}
        {presentaionData?.activePresentation === 'share_screen' && (
          <Box className="flex-1">
            <PeerView
              style={{ height: '100%', width: '100%' }}
              streamURL={shareStream}
            // key={new Date()}
            />
          </Box>
        )}
        <Box className="flex flex-wrap">
          {['share_whiteboard', 'case_url', 'share_screen']?.includes(presentaionData?.activePresentation) &&
            presentaionData?.presentNominee !== profileData?.email && (
              <PeerView
                style={undefined}
                streamURL={allStream[presentaionData?.presentNominee]}
              // key={new Date()}
              />
            )}
          <Box><Trainer name={trainer?.fullname} trainerTableName="On Table 1" /></Box>
          <Box><MyPeerView /></Box>
        </Box>
      </Box>
    );
  }

  if (isPresentationStarted) {
    return (
      <Box className="flex-1">
        {!presentaionData?.activePresentation && (
          <PeerView
            style={undefined}
            streamURL={allStream[presentaionData?.presentNominee]}
          />
        )}
        {presentaionData?.activePresentation === 'share_whiteboard' && (
          <Box className="h-[70vh] w-[96vw] m-[2vw]">
            <iframe
              src={`https://vtt.atwpl.com/whiteboard/boards/${session_id}`}
              className="w-full h-full"
              allow="camera; microphone; fullscreen; display-capture"
            />
          </Box>
        )}
        {presentaionData?.activePresentation === 'case_url' && (
          <Box className="h-[70vh] w-[96vw] m-[2vw]">
            {presentaionData?.fileUrl?.endsWith('.pdf') ? (
              <iframe src={presentaionData?.fileUrl} className="w-full h-full" />
            ) : (
              <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${presentaionData?.fileUrl}`}
                className="w-full h-full"
              />
            )}
          </Box>
        )}
        {presentaionData?.activePresentation === 'share_screen' && (
          <PeerView
            style={undefined}
            streamURL={shareStream}
          />
        )}
        <Flex align="center" className="bg-[#5F488A] px-4">
          <Text className="text-white font-bold">{tblData?.table_name}</Text>
          {presentaionData?.presentNominee === profileData?.email ? (
            <Button onClick={handleEndPresentation} className="flex-1 flex items-center">
              <Text className="text-white">Click to end Presentation</Text>
              <img src={exitPresentation} className="h-6 w-12" alt="exit" />
            </Button>
          ) : (
            <Box className="flex-1" />
          )}
          {/* <Button onClick={() => setShowMenu(!showMenu)}>
              <img src={Images?.vdots} className="h-8 w-10" alt="menu" />
            </Button> */}
          {showMenu && (
            <Box className="absolute top-8 right-0 bg-white p-4 rounded-lg shadow-lg">
              <Text onClick={() => setShowFullscreen(true)} className="cursor-pointer">
                Full Screen
              </Text>
            </Box>
          )}
        </Flex>
        {renderPresentParticipent()}
      </Box>
    );
  }


  return (
    <div className="flex relative flex-col h-full w-full">
      <div className="flex-1  relative oveflow-auto">
        {/* <div className="
            w-full
            z-50
            left-1/2
            -translate-x-1/2
            absolute
            top-5
            mobile:static
            tablet:static
            mobile:left-0
            tablet:left-0
            mobile:translate-x-0
            tablet:translate-x-0
            mobile:flex
            tablet:flex
            mobile:justify-center
            tablet:justify-center
            mobile:mt-5
            tablet:mt-5
          ">
          <Trainer videoHeight={150} videoWidth={250} name={trainer?.fullname} trainerTableName="On Table 1" />
        </div> */}
        {/* {justBecameGroupLeader && (
          <div>
            <CSGroupleader canTransfer={canTransfer}
              onTransfer={() => {
                setIsGlTransfer(true)
                setModalMode(csModalType?.NOMINATEGL)
              }}
              onOkay={OkayGroupleader}
              glmMode={GLMmode} />
          </div>
        )} */}

        {modalMode && <div className={`relative z-0 h-full`}>
          {renderModalContent()}
        </div>
        }
        <div
          ref={containerRef}
          className="flex-1"
        >
          <ViewCSBriefButton activityData={activityData} documentUrl={documentUrl} onBrief={onBrief} />
          {openClassInteraction ? renderOpenClassInteraction() : !modalMode && renderPresentationInGroups()}
        </div>

        {/* {showMyfeed && !openClassInteraction && !hideOurDraggableView && (
          <>
            {!isExpandedTabel && !isUsersDragableCompOpen && !isUsersDragableCompOpens ? (
              <div className="flex items-center bg-[rgba(84,84,85,0.8)] absolute bottom-0 right-5 h-10 w-96 px-4">
                <Button
                  variant="ghost"
                  onClick={() => {
                    setIsUsersDragableCompOpens(true);
                    setIsUsersDragableCompOpen(false);
                  }}
                  className="pr-3"
                >
                  <img
                    src="/assets/plussquare.png"
                    alt="Plus Square"
                    className="h-6 w-6"
                  />
                </Button>

                <Button
                  variant="ghost"
                  onClick={() => setIsUsersDragableCompOpen(true)}
                >
                  <img
                    src="/assets/maximize.png"
                    alt="Maximize"
                    className="h-6 w-6"
                  />
                </Button>

                <div className="flex-1" />

                <Button variant="ghost" onClick={() => { }}>
                  <img
                    src={amImute ? '/assets/micoff.png' : '/assets/mico.png'}
                    alt="Mic"
                    className="h-5 w-5 text-white"
                  />
                </Button>
              </div>
            ) : !isExpandedTabel && isUsersDragableCompOpen ? (
              <div
                className="absolute bg-[rgba(84,84,85,0.8)] h-[55vh] w-[95vw] rounded-lg overflow-hidden"
                style={{ top: '14vh', left: '2vw' }}
              >
                <MyPeerView />
                <div className="flex items-center justify-center h-12 w-96">
                  <Text className="text-white w-80 text-center">{profileData?.name}</Text>
                  <Button variant="ghost" onClick={() => { }}>
                    <img
                      src={amImute ? '/assets/micoff.png' : '/assets/mico.png'}
                      alt="Mic"
                      className="h-5 w-5 text-white"
                    />
                  </Button>
                </div>
                <div className="absolute flex items-center justify-between px-4 w-96 mt-2 right-0">
                  <Button
                    variant="ghost"
                    onClick={() => setIsUsersDragableCompOpen(false)}
                  >
                    <img
                      src="/assets/maximize.png"
                      alt="Maximize"
                      className="h-6 w-6"
                    />
                  </Button>
                </div>
              </div>
            ) : null}

            {isUsersDragableCompOpens && (
              <div className="absolute bg-[rgba(84,84,85,0.8)] h-[25vh] w-96 rounded-lg overflow-hidden z-50">
                <MyPeerView />
                <div className="flex items-center justify-center h-12 w-96">
                  <Text className="text-white w-80 text-center">{profileData?.name}</Text>
                  <Button variant="ghost" onClick={() => { }}>
                    <img
                      src={amImute ? '/assets/micoff.png' : '/assets/mico.png'}
                      alt="Mic"
                      className="h-5 w-5 text-white"
                    />
                  </Button>
                </div>
                <div className="absolute flex items-center justify-between px-4 w-96 mt-2">
                  <Button
                    variant="ghost"
                    onClick={() => setIsUsersDragableCompOpens(false)}
                  >
                    <img
                      src="/assets/minus.png"
                      alt="Minus"
                      className="h-6 w-6"
                    />
                  </Button>
                  <Button
                    variant="ghost"
                    onClick={() => {
                      setIsUsersDragableCompOpen(true);
                      setIsUsersDragableCompOpens(false);
                    }}
                  >
                    <img
                      src="/assets/maximize.png"
                      alt="Maximize"
                      className="h-6 w-6"
                    />
                  </Button>
                </div>
              </div>
            )}
          </>
        )} */}

        {showMyfeed && openClassInteraction && (
          <Trainer name={trainer?.fullname} trainerTableName="On Table 1" />
        )}
      </div>

      <BottomMessage visible={false} />
      <BottomMessageWithIcon
        message={messageCxt.message}
        visible={messageCxt.visible}
        onClose={() => setMessageCxt({ visible: false, message: '' })}
      />

      {showStartPresentation && (
        <Button
          className="absolute bottom-2.5 self-center border-2 border-[#CBCFC1] rounded-lg overflow-hidden"
          onClick={startPresentation}
        >
          <div className="flex items-center bg-gradient-to-br from-[#697051] to-[#697051] via-[#92A894] px-4 py-2">
            <Text className="text-white mr-2">Start Presentation</Text>
            <img
              src="/assets/presentationIcon.png"
              alt="Presentation"
              className="h-5 w-5"
            />
          </div>
        </Button>
      )}
      {extendedTime.visible ? (
        <div
          className={`absolute inset-0 flex justify-center items-center mobile:items-end mobile:justify-center pointer-events-none ${extendedTime.visible ? 'opacity-100' : 'opacity-0'}`}
        >
          <div className="pointer-events-auto w-[40%] mobile:w-full h-[16%] bg-[#24272C] rounded-lg p-5 shadow-lg mb-4 mobile:mb-2">
            <Text className="text-white font-bold text-center">
              Trainer has extended the Case Analysis duration by {extendedTime.time} Minutes
            </Text>
          </div>
        </div>

      ) : null}

      {isTwoMinutesLeft ? (
        <div
          className={`absolute inset-0 flex justify-center items-center mobile:items-end mobile:justify-center pointer-events-none
      ${isTwoMinutesLeft ? "opacity-100" : "opacity-0"}
    `}
        >
          <div className="pointer-events-auto w-[40%] mobile:w-full h-[16%] bg-[#24272C] rounded-lg p-5 shadow-lg mb-4 mobile:mb-2">
            <Text className="text-white font-bold text-center">
              Case Analysis ends in 2mins!
            </Text>
          </div>
        </div>
      ) : null}


      <CsNominateGroupleader
        modalVisible={showNominateModal}
        onNominate={(nominee: any) => {
          const data = { participant_email: profileData.email };
          nominateGroupleader(data);
          setShowNominateModal(false);
        }}
      />

      <CSGroupleader
        modalVisible={showModal}
        onNominate={() => {
          setShowModal(false);
        }}
      />
    </div>
  )
}

export default CaseStudyScreen;

const ViewCSBriefButton = ({ activityData, documentUrl, onBrief }) => {
  console.log("CS1234 documentUrl", documentUrl)
  console.log("CS1234 activityData", activityData)
  const handleClick = () => {
    onBrief({
      attachment_url: documentUrl,
      activityData,
    });
  };

  return (
    <button
      onClick={handleClick}
      className="absolute left-2 top-5 z-[999999] bg-[rgba(33,32,37,0.7)] flex justify-center items-center p-1 rounded"
    >
      <div className="animate-pulse">
        <img
          src={briefIcons}
          alt="Brief"
          className="h-[2vh] w-[2vh] object-contain"
        />
      </div>
    </button>
  );
};